import React from 'react';
import { ProjectsScreen, CompletedProjectsScreen, ProjectStack } from './Projects';
import Tutorial from './Projects/CreateProjectTutorial/Tutorial';
import { createStackNavigator } from '@react-navigation/stack';
import NavOptions from '../constants/NavOptions';
import { useLinkTo } from '@react-navigation/native';

const Stack = createStackNavigator();

const ProjectsStack = ({ navigation }) => {
  const linkTo = useLinkTo();
  
  React.useEffect(() => {
    const unsubscribe = navigation.addListener('tabPress', (e) => {
      // Prevent default behavior
      console.log('tabPress');
      linkTo('/projects');
      // e.preventDefault();

      // Do something manually
      // ...
    });

    return unsubscribe;
  }, [navigation]);

  return (
    <Stack.Navigator initialRouteName='Projects' screenOptions={NavOptions.all}>
    {/* <Stack.Navigator initialRouteName='Projects' screenOptions={{ headerShown: false }}> */}
      <Stack.Screen
        name='Projects'
        component={ProjectsScreen}
        options={{ title: 'Projects' }}
      />
      <Stack.Screen
        name='CompletedProjects'
        component={CompletedProjectsScreen}
        options={{ title: 'Completed Projects' }}
      />
      <Stack.Screen
        name='CreateProjectTutorial'
        options={{ headerShown: false, title: 'Create Project Tutorial' }}
        // component={CreateProjectTutorial}
        component={Tutorial}
      />
      <Stack.Screen
        name='ProjectStack'
        component={ProjectStack}
        // options={{ title: 'Project' }}
      />
    </Stack.Navigator>
  )

}

export default ProjectsStack;
